export const cookieparser = process.server ? require("cookieparser") : undefined

export const strict = false

export const state = () => ({
  counter: 0
})

export const mutations = {
  increment(state) {
    state.counter++
  }
}

export const actions = {
  nuxtServerInit({ commit }, { req }) {
    
    let intro = false, token = null, user = {}

    if (req.headers.cookie) {
      const parsed = cookieparser.parse(req.headers.cookie)
      try {
        // intro = JSON.parse(parsed.intro)
        
        token = parsed.token
        user = JSON.parse(parsed.user)
      } catch (err) {
        // No valid cookie found
      }
    }

    // commit('intro/setIntro', intro)

    commit('member/auth/setToken', token)
    commit('member/auth/setUser', user)
  }
}
